import Icon from '../components/Icon.vue'

Icon.register({
  bone: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M598.9 244.6C624.1 232 640 206.2 640 178V170.4C640 129.3 606.7 96 565.6 96 533.6 96 505.2 116.5 495 146.9 487.4 169.9 483.4 192 456.9 192H183.1C155.7 192 151.5 166.5 144.9 146.9 134.8 116.5 106.4 96 74.4 96 33.3 96 0 129.3 0 170.4V178C0 206.2 15.9 232 41.1 244.6 50.5 249.3 50.5 262.7 41.1 267.4 15.9 280 0 305.8 0 334V341.6C0 382.7 33.3 416 74.4 416 106.4 416 134.8 395.5 144.9 365.1 152.6 342.1 156.6 320 183.1 320H456.9C484.3 320 488.5 345.5 495 365.1 505.2 395.5 533.6 416 565.6 416 606.7 416 640 382.7 640 341.6V334C640 305.8 624.1 280 598.9 267.4 589.5 262.7 589.5 249.3 598.9 244.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bone.js
// module id = nSTN
// module chunks = 144